import { render, staticRenderFns } from "./GiftSelectionDialogII.vue?vue&type=template&id=4708a73f&scoped=true"
import script from "./GiftSelectionDialogII.vue?vue&type=script&lang=js"
export * from "./GiftSelectionDialogII.vue?vue&type=script&lang=js"
import style0 from "./GiftSelectionDialogII.vue?vue&type=style&index=0&id=4708a73f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4708a73f",
  null
  
)

export default component.exports